import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { DiscussionContainer } from 'components/common/discussion';

const FollowDiscussions = () => {
  const {
    pageState: { course }
  } = useReduxState();

  const { data, loading } = useApiData({
    url: `admin/courses/${course.id}/discussions?languageVersion=${course.language}`,
    onlyIf: Boolean(course?.id)
  });

  return (
    <DiscussionContainer
      chapters={data?.chapters || []}
      discussions={data?.discussions || []}
      loading={loading}
    />
  );
};

export default FollowDiscussions;
